import request from '@/utils/http';
// /api-antms
// const API_RECEIPT = '';
const API_TRANSPORT = '/api-antms/transport';
const API_RECEIPT = '/api-antms/receipt';
// 移交单创建
export const generateTransfer = (data) => {
    return request({
        url: `${API_RECEIPT}/transfer/generateTransfer`,
        method: 'post',
        data
    });
};

// 移交单确认
export const transferToConfirm = (data) => {
    return request({
        url: `${API_RECEIPT}/transfer/transferToConfirm`,
        method: 'post',
        data
    });
};

// 移交中心分页查询
export const queryTransferCenterList = (data) => {
    return request({
        url: `api-antms/query/receiptTransfer/queryPage`,
        method: 'post',
        data
    });
};
// 移交中心查询数量接口
export const queryTransferCenterListCount = (data) => {
    return request({
        url: `api-antms/query/receiptTransfer/queryCount`,
        method: 'post',
        data
    });
};

// 移交单明细-分页查询
export const queryReceiptTransferDetailList = (data) => {
    return request({
        url: `${API_RECEIPT}/transfer/queryReceiptTransferDetail`,
        method: 'post',
        data
    });
};

// 移交单明细-添加明细列表
export const queryReceiptAddTransferDetailList = (data) => {
    return request({
        url: `${API_RECEIPT}/transfer/queryReceiptAddTransferDetail`,
        method: 'post',
        data
    });
};

// 移交单确认弹框-列表查询
export const queryToConfirmDetail = (data) => {
    return request({
        url: `${API_RECEIPT}/transfer/queryToConfirmDetail`,
        method: 'post',
        data
    });
};

// 移交单附件-分页查询
export const queryTransferFileList = (data) => {
    return request({
        url: `${API_TRANSPORT}/transport/image/page/receipt/transfer`,
        method: 'post',
        data
    });
};

// 移交中心 - 新增附件通用接口
export const uploadTransferFile = (data) => {
    return request({
        url: `${API_TRANSPORT}/attachment/add`,
        method: 'post',
        data
    });
};
// 移交中心 - 删除附件通用接口
export const deleteTransferFile = (params) => {
    return request({
        url: `${API_TRANSPORT}/attachment/delete`,
        method: 'get',
        params
    });
};
// 移交中心 - 附件分页查询
export const queryTransferFile = (data) => {
    return request({
        url: `${API_TRANSPORT}/attachment/page`,
        method: 'post',
        data
    });
};

// 移交单 - 增加
export const addTransferDetail = (data) => {
    return request({
        url: `${API_RECEIPT}/transfer/addTransferDetail`,
        method: 'post',
        data
    });
};

// 移交单 - 减单
export const subTransferDetail = (data) => {
    return request({
        url: `${API_RECEIPT}/transfer/subTransferDetail`,
        method: 'post',
        data
    });
};
